// extracted by mini-css-extract-plugin
export default {"excluded":"SponsoredBrandsTargetsTable_excluded__-DpjR"};